export enum DateFormatPreference {
  INTERNATIONAL = "INTERNATIONAL",
  US = "US",
}

export const DEFAULT_DATE_FORMAT_PREFERENCE = DateFormatPreference.INTERNATIONAL;

export function parseDateFormatPreference(
  value: string | boolean | undefined,
): DateFormatPreference {
  if (value === DateFormatPreference.US || value === "US") {
    return DateFormatPreference.US;
  }
  return DateFormatPreference.INTERNATIONAL;
}
